import React, { useContext } from "react"

//CONTEXT
import { AuthContextState } from "../context/auth-context/auth-context"

//COMPONENTS
import Bejelentkezes from "../components/Auth/bejelentkezes"
import Bejelentes from "../components/Auth/restrictedPages/bejelentes"
import Head from "../components/head"
import Layout from "../layouts/subpage_layout"
import BreadcrumbsLayout from "../layouts/breadcrumbs_layout"
import { Button, Grid } from "@material-ui/core"
import { graphql, useStaticQuery } from "gatsby"

const PrivateRoute = props => {
  const state = useContext(AuthContextState)

  const data = useStaticQuery(graphql`
    query {
      markdownRemark(frontmatter: { title: { eq: "Bejelentés" } }) {
        frontmatter {
          title
          mainpage
        }
        html
      }
      allCountryMappingCsv {
        nodes {
          key
          hun
        }
      }
      allLanguageMappingCsv {
        nodes {
          key
          hun
        }
      }
      allOdrKonyvtarkodListaCsv(sort: { fields: name, order: ASC }) {
        nodes {
          name
          code
        }
      }
    }
  `)

  //   if (state.accessToken.trim() === "") {
  //     return <Bejelentkezes />
  //   }
  //   return <Bejelentes userName={state.userName} />
  return (
    <>
      <Head title={"Bejelentő űrlap"} />
      <Layout>
        <BreadcrumbsLayout
          menuItems={[{ name: "Főoldal", path: "/" }, { name: "Bejelentés" }]}
        >
          <div
            dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
          ></div>

          {/* <Grid container className={notifyStyles.dataFields}>
                                <form onSubmit={formSubmitHandler} id='bejelento_form'>
                                    {formDisplay}
                                    <Grid container className={notifyStyles.notificationLine}>
                                        <Grid container className={notifyStyles.dataBlockButton} justify="center" alignItems="center">
                                            <Button type='submit' className={notifyStyles.sendButton}>Beküldés</Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid> */}
        </BreadcrumbsLayout>
      </Layout>
    </>
  )
}

export default PrivateRoute
